// Mood / emotional tone - single-select universal across all genres.
// Sent to Claude (lyrics) and Suno (audio style) so the AI can shape the song's emotion.
export const MOODS = [
  {
    key: "fiestero",
    label: "Fiestero",
    emoji: "🎉",
    description: "Energía alta, para celebrar y prender el ánimo",
    claude_hint: "letra alegre, enérgica, con frases de celebración, fiesta y buena vibra",
  },
  {
    key: "romantico",
    label: "Romántico",
    emoji: "❤️",
    description: "Amor, conexión, dedicatoria especial",
    claude_hint: "letra apasionada, dedicatoria de amor, metáforas tiernas y declaraciones del corazón",
  },
  {
    key: "melancolico",
    label: "Melancólico",
    emoji: "💔",
    description: "Nostalgia, despedida, sentimiento profundo",
    claude_hint: "letra nostálgica, melancólica, con sentimiento de pérdida, recuerdos y suspiros",
  },
  {
    key: "motivacional",
    label: "Motivacional",
    emoji: "💪",
    description: "Salir adelante, perseverancia, fuerza",
    claude_hint: "letra de motivación, superación personal, levantarse de los problemas con orgullo",
  },
  {
    key: "orgulloso",
    label: "Orgulloso",
    emoji: "👑",
    description: "Empoderamiento, raíces, lo que vales",
    claude_hint: "letra de orgullo y empoderamiento, presumir las raíces, la familia o lo logrado",
  },
  {
    key: "picante",
    label: "Picante",
    emoji: "🔥",
    description: "Sensual, atrevido, perreo nocturno",
    claude_hint: "letra atrevida, sensual, con doble sentido pero sin caer en groserías; tono coqueto",
  },
  {
    key: "reflexivo",
    label: "Reflexivo",
    emoji: "😌",
    description: "Introspección, recuerdos, lecciones de vida",
    claude_hint: "letra introspectiva, reflexiva, pensamientos profundos y lecciones aprendidas",
  },
  {
    key: "divertido",
    label: "Divertido",
    emoji: "😂",
    description: "Humorístico, picaresco, anécdotas chistosas",
    claude_hint: "letra divertida y humorística, picaresca pero respetuosa, con guiños y anécdotas chistosas",
  },
];
